import { useLocation } from 'react-router';

const useLocationState = () => useLocation().state

export default useLocationState;
